import React, { useState, useImperativeHandle, forwardRef } from 'react'
import PrimeModal from '@/components/primeModal'
import { useTranslation } from 'react-i18next'
import { Form, Input, App } from 'antd'
import { insertDomain } from '@/api/dictionary'

interface AddDirProps {
  onSuccess?: () => void
}

const AddDir = ({ onSuccess }: AddDirProps, ref: any) => {

  const { t } = useTranslation()
  const { message } = App.useApp()
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const open = () => {
    setVisible(true)
  }

  const close = () => {
    setVisible(false)
    form.resetFields()
  }

  useImperativeHandle(ref, () => ({
    open,
    close,
  }))

  const submit = async (values: any) => {
    try {
      await insertDomain({ ...values, moduleType: 1 })
      close()
      message.success(t('ikg.success', { action: t('dict.addDir') }))
      typeof onSuccess === 'function' && onSuccess()
    } catch (error) {
    }
  }
  return (
    <PrimeModal
      title={t('dict.addDir')}
      width={640}
      open={visible}
      onCancel={close}
      onOk={() => form.submit()}
    >
      <Form form={form} layout="vertical" onFinish={submit} autoComplete="off">
        <Form.Item
          label={t('dict.name')}
          name="name"
          rules={[
            {
              required: true,
              message: t('ikg.input', { name: t('dict.name') }),
            },
          ]}
        >
          <Input placeholder={t('ikg.input', { name: t('dict.name') })} />
        </Form.Item>
      </Form>
    </PrimeModal>
  )
}

export default forwardRef(AddDir)
